import { MemreContainer, MemreFlexBox, MemrePeopleList } from 'components/core';
import { MemreDenisityPlot } from 'components/visualisations';
import _ from 'lodash';
import AreaHeading from '../learner-dashboard/visulisations/AreaHeading';
import LearnMore from '../learner-dashboard/visulisations/LearnMore';

const OVERLINE = {
  STUDENTS: 'Average Study Time',
  SETS: 'Average Study Time',
  COURSES: 'Average Course Study Time',
};

interface StudyDurationProps {
  data: any[];
  isStudentsView: boolean;
  isCoursesView?: boolean;
}

export default function StudyDuration({ data, isStudentsView, isCoursesView = false }: StudyDurationProps) {
  const studyDurationInMiliseconds = data.map((d) => d.totalStudyTimeMillis);
  const denomination = data[0]?.totalStudyDenom;
  const mean = _.round(_.mean(studyDurationInMiliseconds));

  const overline = isCoursesView ? OVERLINE.COURSES : isStudentsView ? OVERLINE.STUDENTS : OVERLINE.SETS;
  const heading = `${mean} ${denomination}`;

  const getCourseLink = (item: any) => `/nav/my-knowledge-bank/${item.id}`;

  return (
    <MemreContainer
      size="large"
      direction={{
        xs: 'column',
        lg: 'row',
      }}
    >
      <MemreFlexBox direction="column" gap={2} sx={{ flexGrow: 1 }}>
        <MemreFlexBox justify="space-between" align="center">
          <AreaHeading overline={overline} heading={heading} />
          <LearnMore title="More details" type="info" width={500}>
            <AreaHeading overline={overline} heading={heading} />
            <MemrePeopleList
              data={data}
              denomination={denomination}
              fields={['totalStudyTimeMillis']}
              fieldNames={['Duration']}
              nameLink={isCoursesView ? getCourseLink : undefined}
            />
          </LearnMore>
        </MemreFlexBox>
        <MemreContainer sx={{ gap: 2, pr: '5px', justifyContent: 'space-between' }}>
          <MemreDenisityPlot data={studyDurationInMiliseconds} />
        </MemreContainer>
      </MemreFlexBox>
    </MemreContainer>
  );
}
